import { render, staticRenderFns } from "./privacy2.0-EN.vue?vue&type=template&id=7b8d5860&scoped=true&"
import script from "./privacy2.0-EN.vue?vue&type=script&lang=js&"
export * from "./privacy2.0-EN.vue?vue&type=script&lang=js&"
import style0 from "./privacy2.0-EN.vue?vue&type=style&index=0&id=7b8d5860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8d5860",
  null
  
)

export default component.exports